export {default as Add} from './components/Add';
export {default as ArrowDown} from './components/ArrowDown';
export {default as ArrowDownThin} from './components/ArrowDownThin';
export {default as ArrowLeft} from './components/ArrowLeft';
export {default as ArrowLeftThin} from './components/ArrowLeftThin';
export {default as ArrowRightThin} from './components/ArrowRightThin';
export {default as ArrowUp} from './components/ArrowUp';
export {default as ArrowUpThin} from './components/ArrowUpThin';
export {default as ArrowVertical} from './components/ArrowVertical';
export {default as BackArrow} from './components/BackArrow';
export {default as Bold} from './components/Bold';
export {default as Browser} from './components/Browser';
export {default as Bulb} from './components/Bulb';
export {default as Chat} from './components/Chat';
export {default as Check} from './components/Check';
export {default as Close} from './components/Close';
export {default as CloseThin} from './components/CloseThin';
export {default as Collapse} from './components/Collapse';
export {default as Crop} from './components/Crop';
export {default as DataPickerArrow} from './components/DataPickerArrow';
export {default as Dots} from './components/Dots';
export {default as Download} from './components/Download';
export {default as Drag} from './components/Drag';
export {default as Drag6} from './components/Drag6';
export {default as Duplicate} from './components/Duplicate';
export {default as Duplicate2} from './components/Duplicate2';
export {default as Error} from './components/Error';
export {default as Expand} from './components/Expand';
export {default as Export} from './components/Export';
export {default as File} from './components/File';
export {default as Finder} from './components/Finder';
export {default as Help} from './components/Help';
export {default as Image} from './components/Image';
export {default as Image2} from './components/Image2';
export {default as Info} from './components/Info';
export {default as Info2} from './components/Info2';
export {default as InfoMaterial} from './components/InfoMaterial';
export {default as Italic} from './components/Italic';
export {default as Languages} from './components/Languages';
export {default as Link} from './components/Link';
export {default as MemberLogged} from './components/MemberLogged';
export {default as Move} from './components/Move';
export {default as OrderedList} from './components/OrderedList';
export {default as Override} from './components/Override';
export {default as Palette} from './components/Palette';
export {default as PartialCheck} from './components/PartialCheck';
export {default as Pause} from './components/Pause';
export {default as Pause2} from './components/Pause2';
export {default as Pen} from './components/Pen';
export {default as PenOutline} from './components/PenOutline';
export {default as Pin} from './components/Pin';
export {default as Plaster} from './components/Plaster';
export {default as Play} from './components/Play';
export {default as PlayTriangle} from './components/PlayTriangle';
export {default as Plus} from './components/Plus';
export {default as Plus2} from './components/Plus2';
export {default as PlusCircle} from './components/PlusCircle';
export {default as Preview} from './components/Preview';
export {default as QuestionMark} from './components/QuestionMark';
export {default as Redo} from './components/Redo';
export {default as Refresh} from './components/Refresh';
export {default as Replace} from './components/Replace';
export {default as Ruler} from './components/Ruler';
export {default as Search} from './components/Search';
export {default as Search2} from './components/Search2';
export {default as Search3} from './components/Search3';
export {default as Search4} from './components/Search4';
export {default as Settings} from './components/Settings';
export {default as SmallX} from './components/SmallX';
export {default as Speaker} from './components/Speaker';
export {default as Stop} from './components/Stop';
export {default as ToggleOff} from './components/ToggleOff';
export {default as ToggleOn} from './components/ToggleOn';
export {default as Trash} from './components/Trash';
export {default as Trash2} from './components/Trash2';
export {default as Trash3} from './components/Trash3';
export {default as Underline} from './components/Underline';
export {default as Undo} from './components/Undo';
export {default as UnorderedList} from './components/UnorderedList';
export {default as Upload} from './components/Upload';
export {default as User} from './components/User';
export {default as V} from './components/V';
export {default as Validation} from './components/Validation';
export {default as Video} from './components/Video';
export {default as View} from './components/View';
export {default as Visibility} from './components/Visibility';
export {default as VisibilityHidden} from './components/VisibilityHidden';
export {default as Wand} from './components/Wand';
export {default as X} from './components/X';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/index.js